import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import CloseIcon from '../../../icons/CloseIcon';

import useChatContext from '../../../hooks/useChatContext/useChatContext';
import ChatIcon from '../../../icons/ChatIcon';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      height: `${theme.footerHeight}px`,
      boxShadow: 'inset 0 -1px 0 var(--sib-color_surface-hover-background)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 1em',
      [theme.breakpoints.down('sm')]: {
        height: `${theme.mobileFooterHeight}px`,
      },
    },
    title: {
      display: 'inline-flex',
      alignItems: 'center',
      '& svg': {
        marginRight: '6px',
      },
    },
    closeChatWindow: {
      cursor: 'pointer',
      display: 'flex',
    },
  })
);

export default function ChatWindowHeader() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { setIsChatWindowOpen } = useChatContext();

  return (
    <div className={classes.container}>
      <div></div>
      <div className={clsx(classes.title, 'sib-typo_heading-sm')}>
        <ChatIcon />
        {t('ROOM.CHAT')}
      </div>
      <div
        id="video-calls-close-chat"
        className={classes.closeChatWindow}
        onClick={() => setIsChatWindowOpen(false)}
        onKeyDown={(e) => e.key === 'Enter' && setIsChatWindowOpen(false)}
        role="button"
        tabIndex={0}
      >
        <CloseIcon />
      </div>
    </div>
  );
}
